export default __webpack_public_path__ + "static/media/gucci.18c1cba2.png";